
import { EnumHelper } from "./enum.helper";



enum UserTypeEnum {
    Contractor = 0,
    Visitor = 1,
    Tenant = 2, 
}
    
namespace UserTypeEnum {
    var _textValues={0: {textValue:"Contractor", order:0}, 1: {textValue:"Visitor", order:1}, 2: {textValue:"Tenant", order:2}, };

    export function getTextValue(value:UserTypeEnum){
        return _textValues[value].textValue; 
    }

    export function getValueList(sort?:boolean):Array<{id:number, label:string}>{
        return EnumHelper.getValueList(<any>_textValues, sort);
    }
}

export {UserTypeEnum}





// WEBPACK FOOTER //
// ./enums/UserTypeEnum.ts